import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const VoiceIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Voice",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 32a1.143 1.143 0 0 1-1.143-1.143V1.143a1.143 1.143 0 1 1 2.286 0v29.714c0 .631-.511 1.143-1.143 1.143M3.429 20.571a1.143 1.143 0 0 1-1.143-1.142V12.57a1.143 1.143 0 1 1 2.285 0v6.858c0 .63-.51 1.142-1.142 1.142M9.714 27.429a1.143 1.143 0 0 1-1.143-1.143V5.714a1.143 1.143 0 1 1 2.286 0v20.572c0 .63-.511 1.143-1.143 1.143M28.571 20.571a1.143 1.143 0 0 1-1.142-1.142V12.57a1.143 1.143 0 1 1 2.285 0v6.858c0 .63-.51 1.142-1.143 1.142M22.286 27.429a1.143 1.143 0 0 1-1.143-1.143V5.714a1.143 1.143 0 1 1 2.286 0v20.572c0 .63-.512 1.143-1.143 1.143"
    })
  }));
};
VoiceIcon.displayName = 'VoiceIcon';